export const SEARCH_PUNCH_LIST_ASYNC = 'SEARCH_PUNCH_LIST_ASYNC';
export const SEARCH_PUNCH_LIST_SUCCESS = 'SEARCH_PUNCH_LIST_SUCCESS';

export const CREATE_PUNCH_LIST_ASYNC = 'CREATE_PUNCH_LIST_ASYNC';
export const CREATE_PUNCH_LIST_SUCCESS = 'CREATE_PUNCH_LIST_SUCCESS';

export const GET_PUNCH_LIST_DETAIL_ASYNC = 'GET_PUNCH_LIST_DETAIL_ASYNC';
export const GET_PUNCH_LIST_DETAIL_SUCCESS = 'GET_PUNCH_LIST_DETAIL_SUCCESS';
export const GET_PUNCH_LIST_DETAIL_FAIL = 'GET_PUNCH_LIST_DETAIL_FAIL';

export const CREATE_PUNCH_LIST_ITEM_ASYNC = 'CREATE_PUNCH_LIST_ITEM_ASYNC';
export const CREATE_PUNCH_LIST_ITEM_SUCCESS = 'CREATE_PUNCH_LIST_ITEM_SUCCESS';
export const CREATE_PUNCH_LIST_ITEM_FAIL = 'CREATE_PUNCH_LIST_ITEM_FAIL';

export const UPDATE_PUNCH_LIST_MANAGED_BY_ASYNC =
  'UPDATE_PUNCH_LIST_MANAGED_BY_ASYNC';

export const GET_PUNCH_LIST_ITEM_DETAIL_ASYNC =
  'GET_PUNCH_LIST_ITEM_DETAIL_ASYNC';
export const GET_PUNCH_LIST_ITEM_DETAIL_SUCCESS =
  'GET_PUNCH_LIST_ITEM_DETAIL_SUCCESS';
export const GET_PUNCH_LIST_ITEM_DETAIL_FAIL =
  'GET_PUNCH_LIST_ITEM_DETAIL_FAIL';

export const RESET_PUNCH_LIST = 'RESET_PUNCH_LIST';
export const RESET_PUNCH_LIST_ITEM = 'RESET_PUNCH_LIST_ITEM';

export const UPDATE_PUNCH_ITEM_ASYNC = 'UPDATE_PUNCH_ITEM_ASYNC';
export const UPDATE_PUNCH_ITEM_SUCCESS = 'UPDATE_PUNCH_ITEM_SUCCESS';

export const SEND_PUNCH_ITEM_ASYNC = 'SEND_PUNCH_ITEM_ASYNC';
export const SEND_MULTIPLE_PUNCH_ITEM_ASYNC = 'SEND_MULTIPLE_PUNCH_ITEM_ASYNC';

export const SETUP_PUNCH_LIST_AWS_ASYNC = 'SETUP_PUNCH_LIST_AWS_ASYNC';
export const SETUP_PUNCH_LIST_AWS_SUCCESS = 'SETUP_PUNCH_LIST_AWS_SUCCESS';
export const UPLOAD_PUNCH_LIST_ATTACHMENT_TO_S3_ASYNC =
  'UPLOAD_PUNCH_LIST_ATTACHMENT_TO_S3_ASYNC';
export const UPLOAD_PUNCH_LIST_ATTACHMENT_TO_SERVER_ASYNC =
  'UPLOAD_PUNCH_LIST_ATTACHMENT_TO_SERVER_ASYNC';

//SUBCONTRACTOR

export const GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_ASYNC =
  'GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_ASYNC';
export const GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_SUCCESS =
  'GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_SUCCESS';
export const GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_FAIL =
  'GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_FAIL';

export const EXPORT_PUNCH_LIST_LIST = 'EXPORT_PUNCH_LIST_LIST';

export const SEARCH_SUBCONTRACTOR_PUNCH_LIST_ASYNC =
  'SEARCH_SUBCONTRACTOR_PUNCH_LIST_ASYNC';
export const SEARCH_SUBCONTRACTOR_PUNCH_LIST_SUCCESS =
  'SEARCH_SUBCONTRACTOR_PUNCH_LIST_SUCCESS';
export const GET_LOT_PAID_FEATURE = "GET_LOT_PAID_FEATURE";
export const GET_LOT_PAID_FEATURE_SUCCESS = "GET_LOT_PAID_FEATURE_SUCCESS";

export const GET_EPL_CUSTOM_TERMS = "GET_EPL_CUSTOM_TERMS";


// WEBPACK FOOTER //
// ./src/Punch-List/constants.js